import type { ExternalShippingCarrierAddress } from "@jti/commerce-types";

export const validateExternalCarrierAddress = (storeAddress: ExternalShippingCarrierAddress): boolean =>
  typeof storeAddress.storeId === "string" &&
  storeAddress.storeId.trim().length > 0 &&
  typeof storeAddress.storeName === "string" &&
  storeAddress.storeName.trim().length > 0 &&
  typeof storeAddress.city === "string" &&
  storeAddress.city.trim().length > 0 &&
  typeof storeAddress.streetName === "string" &&
  storeAddress.streetName.trim().length > 0 &&
  typeof storeAddress.streetNumber === "string" &&
  storeAddress.streetNumber.trim().length > 0 &&
  typeof storeAddress.postCode === "string" &&
  storeAddress.postCode.trim().length > 0;
